import React from 'react';
import { useCollection } from 'react-firebase-hooks/firestore';
import { Button, Popconfirm } from 'antd';
import { CheckOutlined, CloseOutlined } from '@ant-design/icons';

import Client from 'containers/app/client';

import { LayoutPage } from 'components/layouts';
import LoadingFullPage from 'components/loading-full-page';

import BookingsTable from 'components/bookings-table';

import './style.css';

const TableActions = (rext, record) => {
  if (record.status === 'cancelled') return null;
  if (record.status === 'accepted') return null;
  if (record.status === 'rejected') return null;
  return (
    <>
      <Popconfirm
        title="Sure reject?"
        onConfirm={() => {
          Client.rejectBookingRequest(record);
        }}
      >
        <Button
          style={{ marginRight: 'var(--margin-01)' }}
          type="danger"
          shape="circle"
          icon={<CloseOutlined />}
        />
      </Popconfirm>

      <Popconfirm
        title="Sure Accept?"
        onClick={() => {
          Client.acceptBookingRequest({
            employer: record.userId,
            bookingRequest: record.id,
          });
        }}
      >
        <Button type="primary" shape="circle" icon={<CheckOutlined />} />
      </Popconfirm>
    </>
  );
};

const BookingRequests = () => {
  const ref = Client.db
    .collection('booking_request')
    .where('worker', '==', Client.currentUserId());
  const refUsers = Client.db.collection('users');

  const [collection, loading, error] = useCollection(ref);
  const [collectionUsers, loadingUsers, errorUsers] = useCollection(refUsers);

  if (loading || loadingUsers) return <LoadingFullPage />;
  if (error) throw new Error(error);
  if (errorUsers) throw new Error(errorUsers);

  const docs = collection.docs.map((a) => {
    const data = a.data();
    return {
      key: a.id,
      id: a.id,
      ...data,
      ...collectionUsers.docs.find((b) => b.id === data.worker).data().info,
    };
  });

  return (
    <LayoutPage className="booking-requets-page -worker">
      <LayoutPage.Container className="wrapper">
        <h1>Booking Requests</h1>
        <BookingsTable
          bookings={docs}
          userKey="userId"
          profile="/employer-detail/"
          actions={TableActions}
        />
      </LayoutPage.Container>
    </LayoutPage>
  );
};

export default BookingRequests;
